import { useSelector } from "react-redux";
import { selectCurrentDataSetId } from "../../../../store/selectors/metaDataSelectors";
import { DataSetIds } from "../../../../utilities/DimensionNames";

const useShowDateCalculation = (): boolean => {
  const dataSetId = useSelector(selectCurrentDataSetId);
  return dataSetId !== DataSetIds.PortfolioMonitoring;
};

export default useShowDateCalculation;
